/* eslint-disable require-yield */
import { Buffer } from 'buffer';
import { select } from 'redux-saga/effects';
import memoryStorage from '@airasia-common/libraries/storage/memoryStorage';
import { NATIVE_LOGIN_STATE_NAME } from '@airasia-common/libraries/constants';
import ssoClient from '@airasia-common/libraries/http/ssoClient';
import {
  ATTR_DEDICATED_FOR_COVID,
  HERO_SIZE,
  THUMBNAIL_SIZE,
} from './constants';

const USER_TIER = 'lTier';
const getLoggedInStatus = ({ user }) => user.status;
const getAuthInfo = ({ user }) => user.authInfo;

export const getHeroImage = (images, size) => {
  const heroImage = images.find(image => image && image.hero_image);
  return (
    heroImage &&
    ((heroImage.links && heroImage.links[size]) ||
      (heroImage.imageLinks && heroImage.imageLinks[size]))
  );
};

export const makeGalleryFromImages = (images, hotelName) => {
  const gallery = [];
  images.forEach(img => {
    const link = img.links[HERO_SIZE] || img.links[THUMBNAIL_SIZE];
    if (link) {
      gallery.push({
        src: link,
        alt: `${img.caption}-${hotelName}`,
        caption: img.caption,
      });
    }
  });
  return gallery;
};

export const makeImageCarouselFromImages = (images, size) => {
  const imagesCarousel = [];
  images.forEach(img => {
    const link = img.links[size];
    if (link) {
      imagesCarousel.push(link);
    }
  });
  return imagesCarousel;
};

export const makeGalleryV2FromImages = images => {
  return images
    .filter(img => img.links[HERO_SIZE] || img.links[THUMBNAIL_SIZE])
    .map(image => {
      const processedImage = {
        ...image,
        links: {
          small: image.links[THUMBNAIL_SIZE] || image.links[HERO_SIZE],
          big: image.links[HERO_SIZE] || image.links[THUMBNAIL_SIZE],
        },
      };

      /* Because the back end is failed to translate the category name
        so we have to take the caption name instead base on the assumption
        that all image will have the caption name equal to category name
       */
      if (image.caption && image.category?.id) {
        processedImage.category = {
          ...image.category,
          name: image.caption,
        };
      } else {
        delete processedImage.category;
      }
      return processedImage;
    });
};

export function* getLoggedInHeader() {
  const loggedInStatus = yield select(getLoggedInStatus);
  const isLoggedInNative = memoryStorage.getItem(NATIVE_LOGIN_STATE_NAME);

  return { member: loggedInStatus || isLoggedInNative ? 1 : 0 };
}

export function mapHotelAttributes(attributes) {
  return (
    attributes &&
    attributes.filter(
      ({ id: attrId }) => attrId === ATTR_DEDICATED_FOR_COVID.id
    )?.length > 0 &&
    ATTR_DEDICATED_FOR_COVID
  );
}

export const rateWithSelectedBedGroupId = (rate, bedGroupId) => {
  return {
    ...rate,
    bedGroups: rate?.bedGroups?.filter(
      ({ id: bedSizeID }) => bedSizeID === bedGroupId
    ),
  };
};

export const getAgeRange = (minAge, maxAge) => ({ minAge, maxAge });

export function* getAuthorizationHeader() {
  const { accessToken } = yield select(getAuthInfo);
  return { Authorization: accessToken };
}

export const getUserTierFromStorage = () => {
  if (typeof localStorage !== 'undefined') {
    const userTier = localStorage.getItem(USER_TIER);
    return userTier && userTier !== 'null' ? userTier : false;
  }
  return false;
};

export function* getExpirationDate(token) {
  try {
    const [headerEncoded, payloadEncoded] = token.split('.');
    const payloadJsonString = Buffer.from(
      payloadEncoded.replace(/-/g, '+').replace(/_/g, '/'),
      'base64'
    ).toString('ascii');
    const payload = JSON.parse(payloadJsonString);
    const expirationDate = new Date(payload.exp * 1000);
    return expirationDate;
  } catch (error) {
    console.error('Error parsing JWT token:', error);
    return null;
  }
}
export function* getRefreshAuthToken() {
  const { refreshToken } = yield select(getAuthInfo);
  return refreshToken;
}
export function* getFavouriteHeader(accessSSOToken, refreshSSOToken) {
  const ssoOrigin = yield ssoClient.authorize();
  const { clientId, apiKey } = ssoOrigin;
  let authRefreshToken = yield getRefreshAuthToken();
  let authToken = yield getAuthorizationHeader();
  authToken = accessSSOToken ? accessSSOToken : authToken?.Authorization;
  authRefreshToken = refreshSSOToken ? refreshSSOToken : authRefreshToken;
  const expirationDate = yield getExpirationDate(authToken);
  let token = {};
  if (expirationDate > new Date()) {
    token = {
      Authorization: authToken,
    };
  } else {
    const newToken = yield ssoClient.refreshSSOToken(
      apiKey,
      clientId,
      authRefreshToken
    );
    token = {
      Authorization: newToken,
    };
  }

  return {
    ...token,
    'Content-Type': 'application/json',
    'x-api-key': apiKey,
    'x-client-id': clientId,
  };
}
